/**
* RevisableText.js
* 
* Created on 14-mei-2014, 13:36:27
*
* @author Ivo Swartjes for Ranj
**/

export default class RevisableText {
    constructor(lpAssetURL, lpLabel, lpType, originalText) {
        this.lpAssetURL = lpAssetURL;
        this.lpLabel = lpLabel;
        this.lpType = lpType;
        this.originalText = originalText;
    }
}
